import React, { useEffect, useState, useContext } from 'react'
import { IconButton } from '@material-ui/core'
import styles from './css/qlik-item-styles.css'
import { QlikUIContext } from '../QlikUIContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFileExcel,
  faExpandAlt,
  faPlusSquare,
  faCompressAlt,
  faMinusSquare
} from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'

const Action = ({ action, name, onFullScreenAction, onExportExcelAction }) => {
  return (
    <div className={styles.widget__action}>
      {
        {
          Excel: (
            <IconButton
              color='primary'
              aria-label={action.Description}
              size='small'
              id='export'
              title={action.Description}
              onClick={() => onExportExcelAction()}
            >
              <FontAwesomeIcon icon={faFileExcel} fixedWidth />
            </IconButton>
          ),
          Fullscreen: (
            <IconButton
              color='primary'
              aria-label={action.Description}
              size='small'
              id='fullscreen'
              title={action.Description}
              onClick={() => onFullScreenAction(name)}
            >
              <FontAwesomeIcon icon={faExpandAlt} fixedWidth />
            </IconButton>
          ),
          ExpandAll: (
            <IconButton
              color='primary'
              aria-label={action.Description}
              size='small'
              id='fullscreen'
              title={action.Description}
              onClick={() => onFullScreenAction(name)}
            >
              <FontAwesomeIcon icon={faExpandAlt} fixedWidth />
            </IconButton>
          ),
          ExpandPivotTable: (
            <IconButton
              color='primary'
              aria-label={action.Description}
              size='small'
              id='expandPivotTable'
              title={action.Description}
              onClick={() => onFullScreenAction(name)}
            >
              <FontAwesomeIcon icon={faPlusSquare} fixedWidth />
            </IconButton>
          )
        }[action.Name]
      }
    </div>
  )
}

export const QlikItem = ({ widget, qApp, transformRatio }) => {
  const context = useContext(QlikUIContext)
  const [t] = useTranslation(['qlik'])

  const [expandModel, setExpandModel] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [showExpandedWidget, setShowExpandedWidget] = useState(false)
  const [pivotTable, setPivotTable] = useState(false)
  const [pivotTableExpanded, setPivotTableExpanded] = useState(false)

  useEffect(() => {
    qApp.getObject(widget.Name, widget.Name).then((vizModel) => {
      if (
        widget.Actions.find((p) => p.Name === 'Excel' && p.Enabled === true) !=
          null ||
        (widget.Actions.find(
          (p) => p.Name === 'ExpandPivotTable' && p.Enabled === true
        ) != null &&
          widget.Type === 'pivot-table')
      ) {
        setExpandModel(vizModel)
      }
      setIsLoading(false)
    })

    setPivotTable(widget.Type === 'pivot-table')
  }, [widget, qApp])

  const left = Math.trunc(Math.trunc(widget.Left / 50) * transformRatio)
  const width =
    Math.trunc(Math.trunc(widget.Width / 50) * transformRatio) + transformRatio

  const exportExcelHandler = () => {
    expandModel.exportData().then((reply) => {
      let url =
        (context.qlikSecure ? 'https://' : 'http://') +
        context.qlikEnvironmentUrl +
        (context.qlikPort ? ':' + context.qlikPort : '') +
        '/qlik' +
        reply.qUrl
      window.open(url, '_blank')
    })
  }

  const handleOnFullScreen = (name) => {
    setShowExpandedWidget(true)
    qApp.getObject('widget_expand', name)
    if (pivotTable) {
      expandPivotTable()
    }
  }

  const handleOnCollapse = () => {
    setShowExpandedWidget(false)
    if (pivotTable && expandModel !== undefined) {
      collapsePivotTable()
    }
  }

  const expandPivotTable = () => {
    expandModel.expandLeft('/qHyperCubeDef', 0, 0, true)
    setPivotTableExpanded(true)
  }

  const collapsePivotTable = () => {
    expandModel.collapseLeft('/qHyperCubeDef', 0, 0, true)
    setPivotTableExpanded(false)
  }

  return (
    <React.Fragment>
      <div
        className={styles.widget}
        id={`widget${widget.Name}`}
        style={{
          top: `${widget.Top}px`,
          left: `${left}px`,
          width: `${width}px`,
          height: `${widget.Height}px`
        }}
      >
        <div className={styles.widget__actions}>
          {widget.Actions.filter((el) => el.Enabled).map((value, index) => {
            return (
              <Action
                key={index}
                action={value}
                name={widget.Name}
                onFullScreenAction={handleOnFullScreen}
                onExportExcelAction={exportExcelHandler}
              ></Action>
            )
          })}
        </div>
        <div
          className={styles.widget__content}
          id={widget.Name}
          style={{ width: `${width}px`, height: `${widget.Height}px` }}
        ></div>
        {isLoading && (
          <div className={styles.loading}>
            <i className='fa fa-circle-o-notch fa-spin fa-3x fa-fw'></i>
            <span className='sr-only'>{t('qlik:qlikItem.loading')}</span>
          </div>
        )}
      </div>

      {showExpandedWidget && (
        <div className={styles.containerFullObject}>
          <div className={styles.widgetActionsFull}>
            <IconButton
              aria-label={t('qlik:qlikItem.contractAll')}
              size='small'
              id='fullscreen'
              title={t('qlik:qlikItem.contractAll')}
              onClick={handleOnCollapse}
            >
              <FontAwesomeIcon icon={faCompressAlt} fixedWidth />
            </IconButton>
            {pivotTable && pivotTableExpanded && (
              <IconButton
                aria-label={t('qlik:qlikItem.contractAll')}
                size='small'
                id='expandPivotTable'
                title={t('qlik:qlikItem.contractAll')}
                onClick={collapsePivotTable}
              >
                <FontAwesomeIcon icon={faPlusSquare} fixedWidth />
              </IconButton>
            )}
            {pivotTable && !pivotTableExpanded && (
              <IconButton
                aria-label={t('qlik:qlikItem.expandAll')}
                size='small'
                id='expandPivotTable'
                title={t('qlik:qlikItem.expandAll')}
                onClick={expandPivotTable}
              >
                <FontAwesomeIcon icon={faMinusSquare} fixedWidth />
              </IconButton>
            )}
            {widget.Actions.filter((el) => el.Enabled).some(
              (p) => p.Name === 'Excel'
            ) && (
              <IconButton
                aria-label={t('qlik:qlikItem.exportExcel')}
                size='small'
                id='export'
                title={t('qlik:qlikItem.exportExcel')}
                onClick={exportExcelHandler}
              >
                <FontAwesomeIcon icon={faFileExcel} fixedWidth />
              </IconButton>
            )}
          </div>
          <div className={styles.widget__content} id='widget_expand'></div>
        </div>
      )}
    </React.Fragment>
  )
}
